export default __webpack_public_path__ + "static/media/loading.131f9b56.mp4";